import { Truck, ChefHat, Headphones, Handshake } from "lucide-react";
import { useLanguage } from "@/i18n";
import { AccentText, Reveal } from "@/components/Reveal";

const ICONS = [Truck, ChefHat, Headphones, Handshake];

export const WhyUs = () => {
    const { t } = useLanguage();
    const items = t("why.items");

    return (
        <section id="perche-noi" data-testid="whyus-section" className="mx-auto max-w-[1600px] px-5 py-24 md:px-12 md:py-32 lg:px-24">
            <Reveal>
                <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-midora-red" data-testid="whyus-overline">
                    {t("why.overline")}
                </p>
                <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
                    <h2 className="max-w-lg font-display text-4xl font-light tracking-tighter sm:text-5xl" data-testid="whyus-heading">
                        <AccentText text={t("why.heading")} accentKey="why" />
                    </h2>
                    <p className="max-w-md text-sm italic leading-relaxed text-midora-red md:text-base" data-testid="whyus-sub">
                        {t("why.sub")}
                    </p>
                </div>
            </Reveal>

            <div className="mt-16 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
                {items.map((item, i) => {
                    const Icon = ICONS[i];
                    return (
                        <Reveal key={item.title} delay={i * 0.08} className="group bg-[#1C2029] p-8 transition-colors duration-500 hover:bg-[#232833] md:p-10">
                            <div data-testid={`whyus-item-${i}`}>
                                <div className="flex items-center justify-between">
                                    <Icon className="h-7 w-7 text-midora-red transition-transform duration-500 group-hover:-translate-y-1" />
                                    <span className="font-mono text-[10px] tracking-[0.2em] text-white/30">{String(i + 1).padStart(2, "0")}</span>
                                </div>
                                <h3 className="mt-8 font-display text-2xl font-light tracking-tight">{item.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-[#DBD1BD]/60">{item.text}</p>
                                <span className="mt-6 block h-px w-0 bg-midora-red transition-all duration-700 group-hover:w-full" />
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </section>
    );
};
